import { render, staticRenderFns } from "./ItemLiveClassScheduleListView.vue?vue&type=template&id=2b6ec802&scoped=true&"
import script from "./ItemLiveClassScheduleListView.vue?vue&type=script&lang=js&"
export * from "./ItemLiveClassScheduleListView.vue?vue&type=script&lang=js&"
import style0 from "./ItemLiveClassScheduleListView.vue?vue&type=style&index=0&id=2b6ec802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ec802",
  null
  
)

export default component.exports